import {
  View,
  Text,
  ScrollView,
  TextInput,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { Button, Image } from "@rneui/base";
import { useStateContext } from "../lib/context";
import { styles } from "../styles/mainStyle";
import { doc, getDocs, collection, getDoc } from "firebase/firestore";
import { updatePassword } from "firebase/auth";
import { auth, db } from "../firebase";
import { signOut } from "firebase/auth";
import { Linking } from "react-native";
import { Icon } from "@rneui/base";
import Feather from "@expo/vector-icons/Feather";

const MyAccount = ({ navigation, route }) => {
  const [direccion, setDireccion] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
    const fetchDireccion = async () => {
      try {
        const docSnap = await getDoc(doc(db, "users", route.params));
        const data = docSnap.data();
        setDireccion(data.direccion ? data.direccion : "Sin dirección");
      } catch (err) {
        setDireccion("Error al obtener la dirección");
      }
    };
    fetchDireccion();
  }, []);

  const logOut = () => {
    signOut(auth)
      .then(() => {
        navigation.replace("Login");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  const handleUpdatePassword = () => {
    const user = auth.currentUser;

    updatePassword(user, newPassword)
      .then(() => {
        alert("Contraseña cambiada con éxito");
        setShowInput(false);
        setNewPassword("");
      })
      .catch((error) => {
        alert(
          "Error al cambiar la contraseña: " +
            (error?.message || "Intente nuevamente")
        );
        console.log("not succes", error);
      });
  };

  // Context
  const { fullCurrentUser } = useStateContext();

  return (
    <ScrollView style={{ backgroundColor: "#F4F6FD" }} scrollEnabled={scroll}>
      <Header title={"Mi Cuenta"} />
      <View
        style={{
          margin: 16,
          backgroundColor: "#fff",
          padding: 16,
          borderRadius: 8,
          shadowColor: "#000",
          borderColor: "#ccc",
        }}
      >
        <View style={{ flexDirection: "row", marginBottom: 8 }}>
          <Text style={{ fontWeight: "bold", marginRight: 8, fontSize: 19 }}>
            Nombre:
          </Text>
          <Text style={{ fontSize: 19 }}>{fullCurrentUser.APELLIDO}</Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 8 }}>
          <Text style={{ fontWeight: "bold", marginRight: 8, fontSize: 19 }}>
            CUIT:
          </Text>
          <Text style={{ fontSize: 19 }}>{fullCurrentUser.CUIT}</Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 8 }}>
          <Text style={{ fontWeight: "bold", marginRight: 8, fontSize: 19 }}>
            Correo Electrónico:
          </Text>
          <Text style={{ fontSize: 19 }}>{fullCurrentUser.MAIL}</Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 8 }}>
          <Text style={{ fontWeight: "bold", marginRight: 8, fontSize: 19 }}>
            Dirección de envío:
          </Text>
          <Text style={{ fontSize: 19 }}>{direccion}</Text>
        </View>
      </View>

      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          marginVertical: 10,
        }}
      >
        <Button
          radius={"sm"}
          type="solid"
          iconRight={true}
          onPress={() => navigation.navigate("Home")}
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
        >
          Seguir Comprando
          <Image
            source={require("../assets/cart-shopping-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button>
        <Button
          radius={"sm"}
          type="solid"
          iconRight={true}
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
          //   onPress={() => navigation.navigate("Orders", route.params)}
          onPress={() => navigation.navigate("Orders")}
        >
          Mis Pedidos
          <Image
            source={require("../assets/user-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button>
      </View>

      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          marginVertical: 10,
        }}
      >
        <Button
          title="DESCARGAR LISTA DE PRECIOS"
          buttonStyle={styles.button2}
          titleStyle={styles.btnTitle}
          // loading={btnLoading}
          onPress={() =>
            Linking.openURL(
              "https://erodistribuciones.com/wp-content/uploads/2025/07/LISTA-ERO-DISTRIBUCIONES-15-07-25-web.xlsx"
            )
          }
        />
        <Button
          title="DESCARGAR CATÁLOGO RAMVEL"
          buttonStyle={styles.button2}
          titleStyle={styles.btnTitle}
          // loading={btnLoading}
          onPress={() =>
            Linking.openURL(
              "https://erodistribuciones.com/wp-content/uploads/2024/02/CATALOGO-RAMVEL-2024_compressed-1.pdf"
            )
          }
        />
      </View>

      <View
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          marginVertical: 10,
        }}
      >
        {!showInput && (
          <Button
            title="Cambiar Contraseña"
            buttonStyle={styles.button}
            titleStyle={styles.btnTitle}
            // loading={btnLoading}
            onPress={() => {
              setShowInput((prev) => !prev);
            }}
          />
        )}

        {showInput && (
          <>
            <View style={{ width: "80%", marginTop: 10 }}>
              <Text
                style={{
                  marginBottom: 4,
                  alignSelf: "flex-start",
                  marginLeft: 0, // aligns with input
                }}
              >
                Nueva Contraseña
              </Text>
              <View style={{ position: "relative", width: "100%" }}>
                <TextInput
                  style={{
                    height: 40,
                    borderColor: "gray",
                    borderWidth: 1,
                    width: "100%",
                    paddingRight: 40, // space for the icon
                    backgroundColor: "#eaf0fe",
                  }}
                  placeholder="Nueva Contraseña"
                  secureTextEntry={!showPassword}
                  onChangeText={setNewPassword}
                  value={newPassword}
                />
                <TouchableOpacity
                  style={{
                    position: "absolute",
                    right: 10,
                    top: 9,
                    zIndex: 2,
                  }}
                  onPress={() => setShowPassword((prev) => !prev)}
                  activeOpacity={0.7}
                >
                  <Feather
                    name={showPassword ? "eye-off" : "eye"}
                    size={22}
                    color="gray"
                  />
                </TouchableOpacity>
              </View>
            </View>
            <Button
              title="Actualizar Contraseña"
              buttonStyle={styles.button}
              titleStyle={styles.btnTitle}
              onPress={handleUpdatePassword}
            />
          </>
        )}
        <Button
          title="Cerrar Sesion"
          buttonStyle={styles.button}
          titleStyle={styles.btnTitle}
          // loading={btnLoading}
          onPress={logOut}
        />
      </View>
    </ScrollView>
  );
};

export default MyAccount;
